import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ children, isLoggedIn }) =>
    !!isLoggedIn ? children : <Navigate to="/" />

export default PrivateRoute